<script module lang="ts">
	export interface BaseListProps {
		token: Tokens.List;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
		variant: TxtVariant;
	}

	export type ListToken = {
		ordered: boolean;
		items: { tokens: [{ tokens: Token[] }]; text: string }[];
	};
</script>

<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';
	import type { Tokens, Token } from 'marked';
	import { twMerge } from 'tailwind-merge';
	import { Txt, type TxtVariant } from '../../../../Txt';
	import { MarkdownInlineTokens } from '../../MarkdownInlineTokens';

	interface Props {
		token: ListToken;
		boldVariant: TxtVariant;
		variant: TxtVariant;
		class?: string;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}

	let { options, renderers, ...props }: Props = $props();
</script>

{#if props.token.ordered}
	<ol class="mb-6 ml-4 list-decimal md:ml-6">
		{#each props.token.items as item}
			<Txt variant={props.variant} component="li" class={twMerge('mb-2 pl-4', props.class)}>
				{#if item.tokens[0]?.tokens}
					<MarkdownInlineTokens
						variant={props.variant}
						class={props.class}
						boldVariant={props.boldVariant}
						tokens={item.tokens[0]?.tokens}
						{options}
						{renderers}
					/>
				{:else}
					{item.text}
				{/if}
			</Txt>
		{/each}
	</ol>
{:else}
	<ul class="mb-6 ml-4 list-disc md:ml-6">
		{#each props.token.items as item}
			<Txt variant={props.variant} component="li" class={twMerge('mb-2 pl-4', props.class)}>
				{#if item.tokens[0]?.tokens}
					<MarkdownInlineTokens
						variant={props.variant}
						class={props.class}
						boldVariant={props.boldVariant}
						tokens={item.tokens[0].tokens}
						{options}
						{renderers}
					/>
				{:else}
					{item.text}
				{/if}
			</Txt>
		{/each}
	</ul>
{/if}
